import React, { useEffect, useState } from "react";
import "./FacebookFeed.css";
import { API_BASE_URL, IMG_BASE } from "../apiConfig";

const FacebookFeed = () => {
    const [instaImages, setInstaImages] = useState([]);
    const [loadingInsta, setLoadingInsta] = useState(true);

    useEffect(() => {
        // Fetch recent images from gallery to mimic an Instagram feed
        const fetchRecentImages = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/gallery`);
                const albums = await response.json();
                
                // We want the latest images. We'll take the cover images from the top 9 albums
                // to show a variety of recent event highlights.
                if (albums && albums.length > 0) {
                    const topImages = albums.slice(0, 9).map(album => ({
                        id: album.GalleryEventId,
                        url: album.CoverImage.startsWith('http') ? album.CoverImage : IMG_BASE + album.CoverImage,
                        title: album.Title
                    }));
                    setInstaImages(topImages);
                }
            } catch (error) {
                console.error("Error fetching Instagram-style highlights:", error);
            } finally {
                setLoadingInsta(false);
            }
        };

        fetchRecentImages();

        // Robust initialization for Facebook SDK
        const initFB = () => {
            if (window.FB) {
                window.FB.XFBML.parse();
            } else {
                // If FB is not yet defined, wait and try again
                setTimeout(initFB, 1000);
            }
        };
        initFB();
        
        if (window.instgrm) {
            window.instgrm.Embeds.process();
        }
    }, []);

    return (
        <section className="social-media-section">
            <div className="container">
                <div className="social-media-header">
                    <h2 className="title">Social Media Feeds</h2>
                    <div className="facebook-divider"></div>
                    <p className="subtitle">
                        Stay connected with Melbourne Kannada Sangha! Explore our latest events, community updates, and vibrant moments shared on our Facebook and Instagram pages.
                    </p>
                </div>

                <div className="social-feeds-grid">
                    {/* FACEBOOK FEED */}
                    <div className="feed-column">
                        <h3 className="feed-title"><i className="fab fa-facebook" style={{ color: '#1877F2', marginRight: '8px' }}></i> Facebook</h3>
                        <div className="facebook-feed-wrapper">
                            <div
                                className="fb-page"
                                data-href="https://www.facebook.com/melbournekannadasangha"
                                data-tabs="timeline"
                                data-width="500"
                                data-height="600"
                                data-small-header="false"
                                data-adapt-container-width="true"
                                data-hide-cover="false"
                                data-show-facepile="true"
                            >
                                <blockquote cite="https://www.facebook.com/melbournekannadasangha" className="fb-xfbml-parse-ignore">
                                    <a href="https://www.facebook.com/melbournekannadasangha">Melbourne Kannada Sangha</a>
                                </blockquote>
                            </div>
                        </div>

                        <div className="visit-btn-container">
                            <a
                                href="https://www.facebook.com/melbournekannadasangha"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="visit-btn facebook"
                            >
                                <i className="fab fa-facebook-f"></i> Visit Facebook
                            </a>
                        </div>
                    </div>

                    {/* INSTAGRAM FEED */}
                    <div className="feed-column">
                        <div className="insta-header-row">
                            <h3 className="feed-title"><i className="fab fa-instagram" style={{ color: '#E1306C', marginRight: '8px' }}></i> Instagram</h3>
                            <a href="https://www.instagram.com/melnudi/" target="_blank" rel="noopener noreferrer" className="insta-handle">@melnudi</a>
                        </div>
                        
                        <div className="instagram-feed-wrapper native-grid">
                            {loadingInsta ? (
                                <div className="insta-loader">
                                    <div className="spinner"></div>
                                    <p>Gathering latest moments...</p>
                                </div>
                            ) : (
                                <div className="insta-native-grid">
                                    {instaImages.length > 0 ? (
                                        instaImages.map((img, index) => (
                                            <a 
                                                key={img.id} 
                                                href="https://www.instagram.com/melnudi/" 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="insta-grid-item"
                                            >
                                                <img src={img.url} alt={img.title} />
                                                <div className="insta-overlay">
                                                    <i className="fab fa-instagram"></i>
                                                </div>
                                            </a>
                                        ))
                                    ) : (
                                        <div className="insta-no-data">
                                            <p>Check back soon for latest updates!</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="visit-btn-container">
                            <a
                                href="https://www.instagram.com/melnudi/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="visit-btn instagram"
                            >
                                <i className="fab fa-instagram"></i> Follow on Instagram
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default FacebookFeed;